const getAppScrollContainer = () =>
  document.querySelector('[data-app-scroll-container="true"]');

export const scrollAppToTop = () => {
  const container = getAppScrollContainer();
  if (container) {
    container.scrollTo({ top: 0, behavior: 'auto' });
    return;
  }

  window.scrollTo({ top: 0, behavior: 'auto' });
};

export const refreshNavigationTarget = ({
  event,
  isActive,
  navigate,
  queryClient,
  queryKeys = [],
  to,
  state = {},
}) => {
  if (!isActive) return;

  event.preventDefault();
  scrollAppToTop();

  queryKeys.forEach((queryKey) => {
    queryClient.removeQueries(queryKey);
    queryClient.invalidateQueries(queryKey);
  });

  const refreshAt = Date.now();
  window.dispatchEvent(
    new CustomEvent('app:navigation-refresh', {
      detail: { to, refreshAt },
    })
  );

  navigate(to, {
    state: {
      ...state,
      navigationRefreshAt: refreshAt,
    },
  });
};
